export default __webpack_public_path__ + "roi-calculator.png";